import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export default makeStyles({
  root: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 800
    }
  },
  icon: {
    transform: 'scale(1.5)',
    color: '#fff',
    width: 22,
    height: 22,
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      height: 16
    }
  },
  iconTitle: {
    transform: 'scale(1.5)',
    color: '#fff',
    width: 16,
    height: 16
  },
  balloonTitle: {
    marginRight: 15
  },
  balloonQuestionTitle: {
    marginRight: 10,
    marginLeft: 6,
    marginTop: 0
  },
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2),
    color: 'rgb(52, 27, 108)',
    display: 'flex',
    justifyContent: 'center'
  },
  balloonIcon: {
    color: 'transparent'
  },
  dialogTitleTypography: {
    position: 'relative',
    top: 3,
    fontWeight: 600,
    fontSize: '15pt'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 11,
    color: theme.palette.grey[500],
    '&:hover': {
      borderRadius: 7
    }
  },
  closeIcon: {
    backgroundColor: '#413292',
    color: 'white',
    borderRadius: 5,
    height: 20,
    width: 20
  },
  dialogContent: {
    padding: '10px 24px 14px',
    [theme.breakpoints.down('md')]: {
      padding: '10px 15px'
    }
  },
  initiativeContainer: {
    marginBottom: 15
  },
  initiativeDescription: {
    position: 'relative',
    top: 3,
    left: 12,
    fontWeight: 600,
    fontSize: '18pt',
    margin: 0,
    marginBottom: 8,
    color: 'rgb(52, 27, 108)',
    display: 'flex'
  },
  questionContainer: {
    display: 'flex',
    marginBottom: 15,
    padding: 5
  },
  questionContainerHover: {
    '&:hover': {
      borderRadius: 2,
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 0px 3px',
      transition: 'all 0.3s ease 0s'
    }
  },
  questionTitleContainer: {
    paddingTop: 0
  },
  questionTitle: {
    color: 'rgb(52, 27, 108)',
    marginLeft: 10,
    fontSize: 18,
    fontWeight: 600
  },
  questionText: {
    marginLeft: 10,
    fontSize: '11pt'
  },
  questionChoiceIcon: {
    paddingLeft: 10,
    minWidth: 'auto'
  },
  playerContainer: {
    margin: 10,
    width: '100%',
    display: 'flex'
  },
  player: {
    border: 0
  }
})
